import VerifyConfirm from "@/components/Verify/Confirm";
import useAppStore from "@/context/store";
import { safeParse } from "@/utils/safeParse";
import axios from "axios";
import { isEmpty } from "lodash";
import { compile } from "path-to-regexp";
import HBMessage from "../components/HBMessage";
import { destroyAll } from "../components/HBModal/ModalWrap";
import LoginDialog from "../components/LoginModal";
import { getCaptchaError } from "./error";
import { REQUEST_MESSAGE_KEY } from "./request";
import { getTransferHeaders } from "./server/headerTransfer";
// 请求拦截器
function requestSuccessFn(config) {
  config.withCredentials = true;
  const {
    url,
    options: { params },
    noParse,
  } = config;

  let target = url;

  if (!noParse && target.indexOf(":") > -1) {
    if (!params || isEmpty(params)) {
      throw new Error(`request ${target}` + "Not found Params!");
    }
    target = compile(url)(params);
    config.url = target;
  }

  if (typeof window == "undefined") {
    const serverTransferHeader = getTransferHeaders();
    config.headers = { ...serverTransferHeader, ...(config.headers || null) };
  }

  return config;
}

// 请求统一错误处理
function requestFailFn(error) {
  console.error("[request error]");
  throw error;
}

// 响应拦截器
function responseSuccessFn(res) {
  const {
    url,
    options: { ignoreMessage },
  } = res.config;
  const { captchaKey, msg, err } = res.data;

  if (captchaKey && err === 500) {
    VerifyConfirm({
      captchakey: captchaKey,
      title: getCaptchaError(msg),
    });
    return {
      err: 555,
      msg: "您操作的频率过快，系统判断您可能是机器人",
    };
  }

  if (res.data.err && !ignoreMessage && typeof window !== "undefined") {
    HBMessage.error({
      content: res.data.msg || res.data.err,
      key: REQUEST_MESSAGE_KEY,
      duration: 3,
    });
  }

  let pagination;
  if (res.headers && res.headers["x-pagination"]) {
    pagination = safeParse(res.headers["x-pagination"]);
  }

  if (!process.browser) {
    return pagination ? { pagination, data: res.data } : res.data;
  }

  let isRegister = true;
  try {
    const response = JSON.parse(res.request.response) || null;
    if (typeof response?.isRegister !== "undefined") {
      isRegister = response.isRegister;
    }
  } catch (err) {}
  const whiteList = ["/auth/", "/message/unreads"];
  if (!whiteList.includes(url) && !isRegister) {
    if (!ignoreMessage && typeof window !== "undefined") {
      HBMessage.error({
        content: "登录失效，请重新登录!",
        key: REQUEST_MESSAGE_KEY,
        duration: 3,
      });
    }
    destroyAll();
    // 清除用户信息
    useAppStore.getState().setUser(null);
    // 登录失效，重定向到了login地址
    LoginDialog.open();

    return {
      err: 500,
      msg: "登录失效，请重新登录!",
    };
  }
  return pagination ? { pagination, data: res.data } : res.data;
}

// 响应统一错误处理
function responseFailFn(error) {
  const msg = error.message || "";

  if (msg.indexOf("timeout") >= 0) {
    error.message = "请求超时，请重试或检查网络状态";
  }

  if (msg.includes("Network Error")) {
    error.message = "网络错误，请重试或检查网络状态";
  }

  throw error;
}

function createRequest({ BaseURL }) {
  const instance = axios.create({
    baseURL: BaseURL,
  });

  // 请求拦截器
  instance.interceptors.request.use(requestSuccessFn, requestFailFn);

  // 响应拦截器
  instance.interceptors.response.use(responseSuccessFn, responseFailFn);

  return instance;
}

export default createRequest;
